export default __webpack_public_path__ + "static/media/newilluminate.d9880940.png";